import { secondToTime } from '@/tools/utils';

// 播放器回放时间转化
Vue.filter('secondToTime', secondToTime);
